<div class="main">
    <div class="group">
        <div class="whoops"><span>Whoops</span></div>
        <div class="icon-404">
            <img src="../../../../assets/svg-pages/plugs.svg" />
        </div>
        <div class="text">
            <span>Something went wrong, please try again later.</span>
        </div>
        <div class="BTN" (click)="navigateToHomePage()">
            <div class="back-to-home">Back to Home</div>
            <div class="frame-2"></div>
        </div>
    </div>
</div>